/**
 * @author Evgeny Shevtsov, info@sitespring.ru
 * @homepage http://sitespring.ru
 * @licence Proprietary
 */
import BaseStore from "./BaseStore";
import ProductProperty from "./ProductProperty";


export default class ProductPropertyStore extends BaseStore {
    static entityName = 'product-property';

    options() {
        return {
            ...super.options(),
            model: ProductProperty,
            fetchParams: {
                fields: 'id,name',
                sort: 'name'
            }
        }
    }
}